import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Artboard" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Artboard",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "ic_check_circle_24px",
				fill: "currentColor",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M10,0 C15.52,0 20,4.48 20,10 C20,15.52 15.52,20 10,20 C4.48,20 0,15.52 0,10 C0,4.48 4.48,0 10,0 Z M14.7857143,5.21428571 C14.5,4.92857143 14.0714286,4.92857143 13.7857143,5.21428571 L10,9 L6.21428571,5.21428571 C5.92857143,4.92857143 5.5,4.92857143 5.21428571,5.21428571 C4.92857143,5.5 4.92857143,5.92857143 5.21428571,6.21428571 L9,10 L5.21428571,13.7857143 C4.92857143,14.0714286 4.92857143,14.5 5.21428571,14.7857143 C5.35714286,14.9285714 5.5,15 5.71428571,15 C5.92857143,15 6.07142857,14.9285714 6.21428571,14.7857143 L10,11 L13.7857143,14.7857143 C13.9285714,14.9285714 14.1428571,15 14.2857143,15 C14.4285714,15 14.6428571,14.9285714 14.7857143,14.7857143 C15.0714286,14.5 15.0714286,14.0714286 14.7857143,13.7857143 L11,10 L14.7857143,6.21428571 C15.0714286,5.92857143 15.0714286,5.5 14.7857143,5.21428571 Z",
					id: "Shape"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgFilled);
export default ForwardRef;
